const rawBase = import.meta.env.BASE_URL || '/'
const normalizedBase = rawBase === '/' ? '' : rawBase.replace(/\/$/, '')

export const withBasePath = (input = '/') => {
  if (!input) {
    return normalizedBase || '/'
  }

  if (/^(?:https?:)?\/\//i.test(input) || input.startsWith('data:')) {
    return input
  }

  const path = input.startsWith('/') ? input : `/${input}`

  if (normalizedBase && path.startsWith(`${normalizedBase}/`)) {
    return path
  }

  if (!normalizedBase) {
    return path
  }

  return `${normalizedBase}${path}`
}

export const resolveAppRoute = (routePath = '/') => {
  if (!routePath) {
    return normalizedBase ? `${normalizedBase}/` : '/'
  }

  const path = routePath.startsWith('/') ? routePath : `/${routePath}`

  if (normalizedBase && path.startsWith(`${normalizedBase}/`)) {
    return path
  }

  if (!normalizedBase) {
    return path
  }

  return `${normalizedBase}${path}`
}
